import React from 'react';

import ActionIcons from './ActionIcons/ActionIcons';
import ActionIconsUsage from './ActionIcons/ActionIconsUsage';

import Badges from './Badges/Badges';
import BadgesUsage from './Badges/BadgesUsage';

import Buttons from './Buttons/Buttons';
import ButtonsUsage from './Buttons/ButtonsUsage/ButtonsUsage';

import Dividers from './Dividers/Dividers';
import DividersUsage from './Dividers/DividersUsage';

import Inputs from './Inputs/Inputs';
import InputsUsage from './Inputs/InputsUsage';

import Links from './Links/Links';
import LinksUsage from './Links/LinksUsage';

import Loadings from './Loadings/Loadings';
import LoadingsUsage from './Loadings/LoadingsUsage';

import Paginations from './Paginations/Paginations';
import PaginationsUsage from './Paginations/PaginationsUsage';

import Tabs from './Tabs/Tabs';
import TabsUsage from './Tabs/TabsUsage';

import Tags from './Tags/Tags';
import TagsUsage from './Tags/TagsUsage/TagsUsage';

import Toggles from './Toggles/Toggles';
import TogglesUsage from './Toggles/TogglesUsage';

import Tooltips from './Tooltips/Tooltips';
import TooltipsUsage from './Tooltips/TooltipsUsage';


/* eslint-disable react/display-name */
const Elements = {
  ActionIcons: () => <ActionIcons />,
  ActionIconsUsage: () => <ActionIconsUsage />,

  Badges: () => <Badges />,
  BadgesUsage: () => <BadgesUsage />,

  Buttons: () => <Buttons />,
  ButtonsUsage: () => <ButtonsUsage />,

  Dividers: () => <Dividers />,
  DividersUsage: () => <DividersUsage />,

  Inputs: () => <Inputs />,
  InputsUsage: () => <InputsUsage />,

  Links: () => <Links />,
  LinksUsage: () => <LinksUsage />,

  Loadings: () => <Loadings />,
  LoadingsUsage: () => <LoadingsUsage />,

  Paginations: () => <Paginations />,
  PaginationsUsage: () => <PaginationsUsage />,

  Tabs: () => <Tabs />,
  TabsUsage: () => <TabsUsage />,

  Tags: () => <Tags />,
  TagsUsage: () => <TagsUsage />,

  Toggles: () => <Toggles />,
  TogglesUsage: () => <TogglesUsage />,

  Tooltips: () => <Tooltips />,
  TooltipsUsage: () => <TooltipsUsage />,
};

export default Elements;



// WEBPACK FOOTER //
// ./src/containers/elements/index.js